// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#outdated {
  font-family: "Open Sans", "Segoe UI", sans-serif;
  display: none;
  background-color: #ffeeee;
  color: white;
  text-align: center;
  width: 100%;
  padding: 12px 0 12px 0;
}

#outdated.fullscreen {
  height: 100%;
}

#outdated .vertical-center {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
}

#outdated h6 {
  display: inline-block;
  font-size: 25px;
  line-height: 25px;
  width: 75%;
  margin: 0 0 12px 0;
}

#outdated p {
  font-size: 12px;
  line-height: 12px;
  margin: 0;
}

#outdated #buttonUpdateBrowser {
  border: 2px solid white;
  color: white;
  cursor: pointer;
  margin: 30px auto 0;
  padding: 10px 20px;
  position: absolute;
  top: -10px;
  right: 60px;
  text-decoration: none;
  width: 230px;
}

#outdated #buttonUpdateBrowser:hover {
  background-color: white;
  color: #f25648;
}

#outdated .last {
  height: 20px;
  position: absolute;
  right: 20px;
  top: 10px;
  width: auto;
  display: inline-table;
}

#outdated .last[dir=rtl] {
  left: 25px !important;
  right: auto !important;
}

#outdated #buttonCloseUpdateBrowser {
  color: white;
  display: block;
  font-size: 36px;
  height: 100%;
  line-height: 36px;
  position: relative;
  text-decoration: none;
  width: 100%;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
